class e {
  shouldRender;
  constructor(o) {
    this.shouldRender = o;
  }
}
export {
  e as Logo
};
//# sourceMappingURL=index.js.map
